import { Gameplay } from "appworks/model/gameplay/gameplay";
import { Record } from "appworks/model/gameplay/records/record";
import { RecordBuilder } from "appworks/server/builders/record-builder";
import { gamevyPartnerConnectSpinRecordBuilder } from "gamevy/integration/builders/records/gamevy-partner-connect-spin-record-builder";
import { GamevyGameSchema, GamevySpinResponseSchema } from "gamevy/integration/schema/gamevy-spin-response-schema";
import { PartnerConnectSpinRequestPayload } from "partner-connect/integration/schema/partner-connect-spin-schema";
import { PartnerConnect, PartnerConnectManager } from "partner-connect/partner-connect-manager";
import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { GridOnlySupplement } from "slotworks/model/gameplay/supplements/grid-only-supplement";
import { TGRBigSymbolSupplement } from "supplements/tgr-big-symbol-supplement";
import { TGRInstantWinsSupplement } from "supplements/tgr-instant-wins-supplement";
import { tgrPartnerConnectSpinRecordBuilder } from "./tgr-partner-connect-spin-record-builder";

export class TGRRecoveryHybridSpinRecordBuilder implements RecordBuilder {

    public id: string = "TGRRecoveryHybridSpinRecordBuilder";

    public filter(request: PartnerConnectSpinRequestPayload, response: PartnerConnect.SpinResponse): boolean {
        return request instanceof PartnerConnectSpinRequestPayload && request.type === "history" && request.cmd !== "C" && response !== undefined;
    }

    public build(gameplay: Gameplay, request: PartnerConnectSpinRequestPayload, response: PartnerConnect.SpinResponse): Record[] {
        const pcRecords = tgrPartnerConnectSpinRecordBuilder.build(gameplay, request, response);

        const betObj = response.wager.bets[0];
        const clientData: GamevyGameSchema = betObj.eventdata.response.clientData as GamevyGameSchema;

        const hybridResponse: any = Object.assign({
            data: { game: clientData } as GamevySpinResponseSchema
        }, response);

        const gRecord = gamevyPartnerConnectSpinRecordBuilder.build(gameplay, request, hybridResponse)[0];

        new TGRBigSymbolSupplement().process(gRecord);
        new TGRInstantWinsSupplement().process(gRecord);
        new GridOnlySupplement().process(gRecord);

        let hybridRecord: SpinRecord | FreespinRecord = Object.assign(pcRecords[0], gRecord);

        if (clientData.type === "freeSpins") {
            const freespinsRecord: FreespinRecord = new FreespinRecord();
            hybridRecord = Object.assign(freespinsRecord, hybridRecord);
            hybridRecord.lastChild = clientData.remainingSpins === 0;
        } else if (clientData.remainingSpins > 0) {
            hybridRecord.hasChildren = true;
            hybridRecord.lastChild = true;
        }

        return [ hybridRecord ];
    }
}

export const tgrRecoveryHybridSpinRecordBuilder = new TGRRecoveryHybridSpinRecordBuilder();
